import React, { Component } from "react"
import { graphql, Link } from "gatsby";
import { Helmet } from "react-helmet";
import { Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Layout from "../../components/layout";
import ReactGA from 'react-ga'
import "../../css/style.css";
import "../../css/animate.min.css";
import "../../css/responsive.css";
import "../../css/bootstrap.min.css";
import check from '../../images/check-icon.svg'
import InstituteTabs from "../../components/institutiontabs";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import ScrollAnimation from 'react-animate-on-scroll';
import {Animated} from "react-animated-css";
import PopupForm from "../../components/popupForm";
import cardImg from '../../images/programs/degree.svg'
import cardImg1 from '../../images/programs/start online.svg'
import cardImg2 from '../../images/programs/get your visa.svg'
import cardImg3 from '../../images/programs/completed overseas.svg'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);

class Countries  extends Component {
    constructor(props){
        super(props);
        this.state ={
            time: 90000000
        }
        
        this.readmoreFucnction = this.readmoreFucnction.bind(this)
        this.readmoreFucnction2 = this.readmoreFucnction2.bind(this)
        this.readmoreFucnction3 = this.readmoreFucnction3.bind(this)     
    }
    
    componentDidMount(){
        var swiper = new Swiper('.universities-swiper',  {
            slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                slidesPerColumn: 1,
                spaceBetween: 0,
                observer: true,
                observeParents: true,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                slidesPerColumn: 1,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 3,
                slidesPerColumn: 2,
                spaceBetween: 10,
                observer: true,
                observeParents: true,
            }
        }
    });
    var swiper = new Swiper('.universities-swiper',  {
        slidesPerView: 3,
    slidesPerColumn: 2,
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            slidesPerColumn: 1,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 2,
            slidesPerColumn: 1,
            spaceBetween: 20,
            observer: true,
            observeParents: true,
        },
        // when window width is >= 640px
        768: {
            slidesPerView: 3,
            slidesPerColumn: 2,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
        }
    }
});
var swiper = new Swiper('.universities-swiper',  {
    slidesPerView: 3,
slidesPerColumn: 2,
spaceBetween: 10,
observer: true,
observeParents: true,
pagination: {
    el: '.swiper-pagination',
    clickable: true,
},
breakpoints: {
    // when window width is >= 320px
    320: {
        slidesPerView: 1,
        slidesPerColumn: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
    },
    // when window width is >= 480px
    480: {
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
    },
    // when window width is >= 640px
    768: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
    }
}
});
 

var swiper = new Swiper('.blogs-swiper', {
    slidesPerView:2,
    spaceBetween: 5,
    autoplay: true,
    // direction: 'vertical',
    speed: 300,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView:1,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        // when window width is >= 480px
        992: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
            slidesPerView: 3,
            spaceBetween: 30,
        }
    }
});


}
readmoreFucnction=()=>{
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

 readmoreFucnction2=()=> {
    var dots = document.getElementById("dots2");
    var moreText = document.getElementById("more2");
    var btnText = document.getElementById("myBtn2");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

 readmoreFucnction3() {
    var dots = document.getElementById("dots3");
    var moreText = document.getElementById("more3");
    var btnText = document.getElementById("myBtn3");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
    }
    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }
  render(){

    const uniArr = this.props.data.allWordpressWpUniversities.nodes

    const cardData = [
        {
            image: cardImg, title: "Choose Your University", text: "Get admission into a business degree at one of our top-ranked universities in the UK"
        },
        {
            image: cardImg1, title: "Start Online", text: "Complete the first half of Year 1 online in just 3.5 months (2 modules in 7 weeks)  without any delays thanks to multiple intakes (intake every 2 months)"
        },
        {
            image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go overseas by the end of the program"
        },
        {
            image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights"
        }
    ]
    
   
    return( 
        <div clsss="countrie-page">
            {/* <PopupForm time={this.state.time} /> */}
            <Layout>
                <Helmet>
                    <title>
                        Study Abroad in the UK | The WorldGrad
                    </title>
                    <meta
                        name="description"
                        content="Planning to study abroad in the UK? Get to know about some of our top universities, cost of living, visa requirements, scholarships in the UK and pursue your dream of studying overseas via The WorldGrad’s affordable and quality online education programs."
                    />
                    <meta
                        name="keywords"
                        content="best countries to study abroad, study abroad scholarships, top countries to study abroad, study abroad scholarships in india, countries to study abroad, study abroad scholarships for students,"
                    />
                </Helmet>
                <section class="countrie-banner-sec" id="country-page-banner-section-uk">    <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible={true}>  
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="countrie-banner-inner" >
                                    <ol class="transparentbreadcrumb breadcrumb">
                                        <li class="breadcrumb-item"><a href="/">The WorldGrad </a></li> 
                                        <li class="breadcrumb-item active"> Countries</li>
                                    </ol>
                                    <div class="text-box wow fadeInUp" data-wow-duration="1s" data-wow-delay=".1s" id="country-banner-image-container">
                                        <h3>Learn About Studying In The United Kingdom (UK)</h3>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>   </Animated> 
                </section>

                <section style={{ backgroundColor: "#fff" }} className="py-md-1">
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/UK/uk_banner_ig48ad.jpg" alt=""
                                        class="img-fluid countries-page-images"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>The UK: Overview</h3>
                                    {/* <p className="country-usa-overview">
                                        The UK is known for its world-renowned universities and innovative teaching approach.  The UK education system gives students <span id="dots2">...</span><span id="more2"> the freedom to tailor their degree to their needs and a world class faculty to boost. A UK education is sure to open doors wherever you go in the world. Add to that an amazing student life experience and huge international student population making the UK an even more attractive destination. </span><a href="javascript:void(0)" onClick={() => this.readmoreFucnction2()} id="myBtn2">Read more</a>
                                    </p> */}
                                    <p className="country-usa-overview">
                                        The UK is known for its world-renowned universities and innovative teaching approach.  The UK education system gives students the freedom to tailor their degree to their needs and a world class faculty to boost. A UK education is sure to open doors wherever you go in the world. Add to that an amazing student life experience and huge international student population making the UK an even more attractive destination.
                                    </p>
                                    <ul>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Over 6,00,000 international students go to study in the UK every year</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Home to some of the best schools and universities in the world such as Oxford and Cambridge</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Bursting with art and culture; over 300 languages spoken in London alone</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>New post-study work  regulations make it easier for international students to gain employment</li>
                                    </ul>
                                    <p className="country-usa-overview">
                                        Know more about <a href="https://theworldgrad.com/blog-detail/why-should-you-consider-studying-in-the/" target="_blank">studying in the UK</a> 
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6 order-first order-md-last">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/UK/Uk_second_banner_tytyst.jpg" alt=""
                                        class="img-fluid countries-page-images"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>Cost Of Education In The UK</h3>

                                    <ul>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>University Tuition Fees</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Depending on the course you choose and the institution you enrol in, the annual fees can vary significantly between GBP 12,000 to GBP 32,000
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Average Student Living Costs</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Depending on your city of residence and spending habits, average living expenses are likely to vary from GBP 1,000 to GBP 1,200 per month
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Scholarships and Savings with The WorldGrad</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                By completing a part of Year 1 online from home with The WorldGrad you can save up to GBP 12,000: ~GBP 5000 in tuition fees and ~GBP 7,000 in living costs 
                                            </p>
                                        </li>
                                    </ul>
                                    <p className="country-usa-overview-mini">
                                        Get more understanding of <a href="https://theworldgrad.com/blog-detail/cost-of-education-in-the-uk/" target="_blank">cost of education in the UK</a>
                                    </p>

                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                <section style={{ backgroundColor: "#fff" }} className="py-md-1">
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/UK/uk_visa_11zon-min_d4gsep.jpg" alt=""
                                        class="img-fluid"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>UK Student Visa Guidance</h3>

                                    <p className="country-usa-overview-mini">
                                        A Confirmation of Acceptance of Studies Certificate is required from the overseas institution to apply for a student visa in the United Kingdom
                                    </p>

                                    <ul>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Visa Requirements</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                In addition to the Confirmation of Acceptance of Studies Certificate, you have to present proof of sufficient funds to cover airfares, tuition fees and living expenses. You will also be required to demonstrate English language proficiency based on the recognized standardized tests like IELTS
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Timelines</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Your student visa will take a maximum of 3 weeks to be processed and allows you to stay in the UK for up to 2 years after your graduation. This is true for both UG as well as PG students
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Post Study Work-Rights</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                You are eligible to look for work in the UK for up to 2 years after graduation. Upon securing a job or the end of the 2 year period you can apply for PSWR to extend your stay
                                            </p>
                                        </li>
                                    </ul>

                                    <p className="country-usa-overview-mini">
                                        Read more information about the <a href="https://theworldgrad.com/blog-detail/uk-student-visa-everything-you-need-to-know/" target="_blank">UK student visa</a>
                                    </p>

                                </ScrollAnimation>
                                <a
                                    class="btn-default visa-visit-btn mx-auto"
                                    href="https://www.gov.uk/student-visa/applyl"
                                    target="_blank"
                                    onClick={() => {
                                        this.handlePopupWindow()
                                        ReactGA.event({
                                            category: "Countries",
                                            action: "Clicks",
                                            label: "Visit Visa Website - Our Visa Guidance for Australia"
                                        })
                                    }}
                                >
                                    VIsit VISA website
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6 order-first order-md-last">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/giorgio-trovato-WyxqQpyFNk8-unsplash-min-_1_.webp" alt=""
                                        class="img-fluid countries-page-images"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>Employability & Careers In The UK</h3>

                                    <ul>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Industries</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                The diversified economy of the UK has a GDP of USD 2.38 trillion which makes it the 6th largest economy in the world. Services industry which consists of many industries like finance, business services, food & beverage, entertainment and retail accounts for more than 3 quarters of the GDP making it the largest sector. Other major contributors are manufacturing, production and agriculture which account to almost 22%
                                                <br />
                                                <a href="https://www.investopedia.com/articles/investing/042915/how-uk-makes-money.asp" target="_blank">Source</a>
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Careers</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Some of the top career choices in the UK are:
                                                <br />
                                                1. Finance Manager
                                                <br />
                                                2. Business Analyst
                                                <br />
                                                3. Software Engineer
                                                <br />
                                                4. Data Scientist
                                                <br />
                                                5. Marketing Executive
                                                <br />
                                                6. Project Manager
                                                <br />
                                            </p>
                                            <p className="country-usa-overview-mini">
                                                Get to know more about <a href="https://theworldgrad.com/blog-detail/best-careers-after-bachelors-in-uk/" target="_blank">careers in the UK</a>
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Salary</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Median salary of a fresh graduate in the UK generally ranges from GBP 16,800 - 25,200
                                            </p>
                                        </li>
                                    </ul>

                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                <section style={{ backgroundColor: "#fff" }} className="py-md-1">
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container-last justify-content-center">
                            <div className="col-md-6">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <h3 className="mb-2 mb-md-4 text-center pt-4 pt-md-0"> Credit Issuing Partner </h3>
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Unismarter-by-Navitas.png" alt=""
                                        class="img-fluid mb-3 d-flex mx-auto shadow p-1"
                                        style={{ borderRadius: "15px", width: "250px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>The WorldGrad Path To A Degree In The UK</h3>

                                    <p className="country-usa-overview"> Fast track your overseas education from one of the best universities in The UK with the help of the Unismarter program</p>

                                    <ul>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>With The WorldGrad’s Unismarter you can complete the first semester of your course from home</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>From semester 2, you can move to a top ranked university campus and complete your degree</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Unismarter helps you complete your dream career with savings of up to GBP 15,000 - 20,000</li>
                                    </ul>

                                    <a
                                        class="btn-default visa-visit-btn mx-auto"
                                        href="/unismarter"
                                        onClick={() => {
                                            ReactGA.event({
                                                category: "Countries",
                                                action: "Clicks",
                                                label: "Visit Visa Website - Our Visa Guidance for Australia"
                                            })
                                        }}
                                    >
                                        Know More
                                    </a>

                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <div class="universitie-partner-sec" > */}
                    <div class="container" style={{ backgroundColor: "#f8f8f8" }}>
                        <div class="row">
                            <div class="col-12">
                                {/* <div class="title"> */}
                                    <h2 className="text-center mb-0 mt-md-4">Featured Universities</h2>
                                {/* </div> */}
                                <Tabs>
                                    <TabPanel>
                                        <section id="dunkles" class="tab-panel">
                                            <div class="interest-explore-inner">
                                                <div class="swiper-container universities-swiper">
                                                    <div class="swiper-wrapper row justify-content-center m-0">
                                                        {
                                                            uniArr.map(university => {
                                                                return (
                                                                    <div className="col-md-4" key={university.id}>
                                                                        <Link to={`/university-detail/${university.slug}`}>
                                                                            <div class="swiper-slide" value="Open" onClick={() => {
                                                                                // this.openModal5()
                                                                                ReactGA.event({
                                                                                    category: "Institutions",
                                                                                    action: "Clicks",
                                                                                    label: `UK - ${university.title}`
                                                                                })
                                                                            }}>
                                                                                <InstituteTabs
                                                                                    ImageUrl={university.acf.university_thumbnail.source_url}
                                                                                    UniversityName={university.title}
                                                                                />
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                {/* </div> */}

            </Layout>
        </div>    
    )
  }
}
export default Countries;

export const WorldGradUniversities = graphql`
    {
        allWordpressWpUniversities(filter: {acf: {country: {eq: "UK"}}}) {
        nodes {
            id
            slug
            title
            acf {
                university_thumbnail {
                    source_url
                }
            }
        }
        }
    }
`
